import React, { useEffect, useState } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth, useRoles } from 'src/common/context'
import { PartnerRole } from 'src/common/static'

type AuthType = 'guest' | 'protected'

interface RequireAuthProps {
  children: JSX.Element
  authType: AuthType
  // When set, the logged-in user must hold at least one of these roles (OR semantics).
  requiredRoles?: PartnerRole[]
}

const RequireAuth: React.FC<RequireAuthProps> = ({ authType, children, requiredRoles }: RequireAuthProps) => {
  const { loading, user, getPreferredMfa } = useAuth()
  const { hasAnyRole } = useRoles()
  const [mfaChecked, setMfaChecked] = useState<boolean | null>(null)
  const location = useLocation()

  const proceed = (): boolean => {
    switch (authType) {
      case 'protected':
        return user ? true : false

      case 'guest':
        return mfaChecked === null && user ? true : !mfaChecked

      default:
        return true
    }
  }

  useEffect(() => {
    // if there's a logged user and bypass is not enabled, ensure matched MFA
    const checkMfa = async () => {
      if (!user) {
        setMfaChecked(null)
        return
      }
      try {
        const preferred = await getPreferredMfa()
        setMfaChecked(preferred !== 'NOMFA')
      } catch (err) {
        // if we fail to determine, be conservative and treat as not configured
        setMfaChecked(false)
      }
    }

    checkMfa()
  }, [user, getPreferredMfa])

  if (loading) {
    return <></>
  } else if (proceed()) {
    if (authType === 'protected' && requiredRoles && requiredRoles.length > 0 && !hasAnyRole(...requiredRoles)) {
      return <Navigate to="/access-denied" state={{ from: location, requiredRoles }} />
    }
    return children
  } else if (authType === 'guest') {
    return <Navigate to="/" state={{ from: location }} />
  } else {
    // if auThype === 'protected'
    return <Navigate to="/login" state={{ from: location }} />
  }
}

export default RequireAuth
